import React from "react";
import lottieSource from "../assets/lottie/write-file.json";
import Lottie from "lottie-react-native";
import { View, StyleProp, ViewStyle } from "react-native";
import Text from "./Text";

type AssetWaitingViewProps = {
    description: string | null;
    style?: StyleProp<ViewStyle>;
};

/**
 * Use to display a waiting animation while an asset is creating in the backend
 * @param description Text to display
 * @param style Style of the component
 * @constructor
 */
export const AssetWaitingView: React.FC<AssetWaitingViewProps> = ({
    description = null,
    style,
}) => {
    return (
        <View style={[{ flex: 0, width: "100%" }, style]}>
            <Lottie
                autoPlay
                loop
                resizeMode="contain"
                source={lottieSource}
                style={{
                    flex: 0,
                    height: 100,
                    alignSelf: "center",
                }}
            />
            <View style={{ justifyContent: "center", alignItems: "center" }}>
                <Text>{description}</Text>
            </View>
        </View>
    );
};
